var render, staticRenderFns
import script from "./DialogMixin.vue?vue&type=script&lang=js"
export * from "./DialogMixin.vue?vue&type=script&lang=js"
import style0 from "./DialogMixin.vue?vue&type=style&index=0&id=322fe9b0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports